import { AccountCompanyInvitation, AnyAccountInvitationEntity } from './invitationModel';

export function isCompanyInvitation(
    item: AnyAccountInvitationEntity
): item is AccountCompanyInvitation {
    return item.kind === 'company';
}
